export async function noopAsync(...args: any[]): Promise<any> {}
